import _ from 'lodash'
import module from './module'

const res = _.merge({},
  module,
)

export default res
